import { render, staticRenderFns } from "./ProjectCompleted.vue?vue&type=template&id=9b972d4e&"
import script from "./ProjectCompleted.vue?vue&type=script&lang=js&"
export * from "./ProjectCompleted.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports